import HttpService from '@/api/HttpService';
import { downloadCSVBlob } from '../../util';

export default {
  namespaced: true,
  actions: {
    exportDocumentViewsReport({ commit }) { // eslint-disable-line no-unused-vars
      return HttpService.getV2('reports/document-views').then(blob => downloadCSVBlob('document_views.csv', blob));
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/documentViews.js